import React from 'react';
import { faClone } from '@fortawesome/free-regular-svg-icons';
import { faLongArrowAltRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './LinkButton.module.css';
import { CommonButton } from '_components';


export class CopyButton extends React.Component {
    render() {
        let cls;
        cls = styles.button;

        if (this.props.className) {
            cls += ' ' + this.props.className;
        }

        return (
            <CommonButton title={this.props.title ? this.props.title : 'Copy'} onClick={this.props.onClick} size={this.props.size} className={cls} >
                <span className='fa-layers fa-fw'>
                    <FontAwesomeIcon icon={faClone} transform="up-3 left-2 shrink-6" color="white" />
                    <FontAwesomeIcon icon={faLongArrowAltRight} transform="up-4 left-1 shrink-11" color="white" />
                </span>
            </CommonButton>
        );
    }
}
